import { format, isValid, parseISO } from 'date-fns';
import consoleEvents from '../consoleEvents';
import getLocaleFile from './getLocaleFile';
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
const formatDate = (getFormatters) => (date, pattern = 'defaultDate') => {
    const formattingPatterns = getFormatters();
    const datePatterns = formattingPatterns.dateFormatter;
    const dateFormat = (datePatterns && datePatterns[pattern]) || DEFAULT_DATE_FORMAT;
    if (!isValid(parseISO(date))) {
        consoleEvents.error(`Expected a valid ISO 8601 date string but got ${date} instead`);
        return null;
    }
    return format(parseISO(date), dateFormat, { locale: getLocaleFile() });
};
export default formatDate;
//# sourceMappingURL=formatDate.js.map